module.exports = __webpack_public_path__ + "img/skating008.82a3f68d.jpg";